/*
@value        : принимаемое значение телефона на данный момент
@callback     : исполняемая функция с отредактированным номером @value (как правило какой-нибудь setState)
@phoneCode    : код страны, для которой применяется маска той самой страны (например, для России это будет +7)
@phoneLength  : число, обозначает длину телефона в стране, в России это 10
*/

const maskPhoneInput = (value, phoneCode = '+7', phoneLength = 10, callback) => {
  let phone = value.replace(/[^0-9.+]/g, '');

  // Убеждаемся, что в маске присутствует только один '+'
  if (phone.startsWith('+')) {
    phone = '+' + phone.replace(/[^0-9]/g, '');
  } else {
    phone = phone.replace(/[^0-9]/g, '');
  }

  // Если длина номера соответствует заданной длине без кода страны, добавляем код страны
  if (phone.length === phoneLength && !phone.startsWith(phoneCode)) {
    phone = phoneCode + phone;
  }

  // Ограничиваем длину номера с кодом страны до общего числа цифр
  const maxPhoneLength = phoneCode.replace('+', '').length + phoneLength;

  if (phone.replace(/[^0-9.]/g, '').length <= maxPhoneLength) {
    callback(phone);
  }
}

export default maskPhoneInput;